import React, { useEffect } from 'react';

const SiteSettingsPage = () => {
    useEffect(() => {
        document.title = 'PayzoPay - Site Ayarları';
    }, []);

    return (
        <div style={{ padding: '20px', color: 'var(--text-color)' }}>
            <h2>Site Ayarları</h2>
            <div className="card" style={{ background: 'var(--card-bg)', padding: '20px', borderRadius: '8px' }}>
                <p>Genel site yapılandırması ve ayarlar burada yapılacak.</p>
            </div>
        </div>
    );
};

export default SiteSettingsPage;